import { Capacitor, registerPlugin } from "@capacitor/core";

interface AudioFocusPlugin {
    request(): Promise<void>;
    abandon(): Promise<void>;
}

const AudioFocus = registerPlugin<AudioFocusPlugin>("AudioFocus");

// Android-only: holds AudioManager focus for the whole recording so
// background media (e.g. Spotify) stays paused instead of flapping when
// Chromium's WebAudio engine recreates its internal output stream — see
// AudioFocusPlugin.java for why that happens.
export async function requestAudioFocus(): Promise<void> {
    if (Capacitor.getPlatform() !== "android") return;
    await AudioFocus.request();
}

export async function releaseAudioFocus(): Promise<void> {
    if (Capacitor.getPlatform() !== "android") return;
    await AudioFocus.abandon();
}
